import dayjs from 'dayjs'
import { useLocalSearchParams } from 'expo-router'

import { ChooseDateScreen } from '@/src/features/community/ui/screens/ChooseDateScreen'
import { ONE_DAY_IN_MS } from '@/src/general/constants/time'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'

const JoinDateScreen = () => {
  const searchParams = useLocalSearchParams()

  const { idSlug } = filterSearchParams<TIdSlugParam>(searchParams)

  return (
    <ChooseDateScreen
      idSlug={idSlug}
      searchParams={searchParams}
      today={dayjs.utc().toDate()}
      initialDate={dayjs().utc().add(ONE_DAY_IN_MS, 'milliseconds').toDate()}
    />
  )
}

export default JoinDateScreen
